<template>
    <div class="widget widget--kyc">
        <div class="label--half">
            <custom-input :value="firstName"
                name="firstName"
                :label="$t('profile.identityInfoPage.firstName')"
                :placeholder="$t('profile.identityInfoPage.firstNameHint')"
                :validations="nameValidations"
                required
                validate-on-mount
                :is-valid.sync="validFirstName"
                @input="$emit('update:firstName', $event)"
            />
        </div>

        <div class="label--half">
            <custom-input :value="lastName"
                name="lastName"
                :label="$t('profile.identityInfoPage.lastName')"
                :placeholder="$t('profile.identityInfoPage.lastNameHint')"
                :validations="nameValidations"
                required
                validate-on-mount
                :is-valid.sync="validLastName"
                @input="$emit('update:lastName', $event)"
            />
        </div>

        <div class="label--half">
            <custom-input :value="dateOfBirth"
                name="dateOfBirth"
                type="date"
                min="1900-01-01"
                :max="minimumAgeYear"
                :label="$t('profile.identityInfoPage.dateOfBirth')"
                :validations="dateOfBirthValidations"
                :is-valid.sync="isDateOfBirthValid"
                :validate-on-mount="Boolean(dateOfBirth)"
                required
                @input="$emit('update:dateOfBirth', $event)"
            />
        </div>

        <div class="label label--half label--bottom-padding">
            {{ $t('profile.identityInfoPage.nationality') }}:

            <country-dropdown :country="nationality"
                :placeholder="$t('profile.identityInfoPage.nationalityHint')"
                @update:country="(args) => $emit('update:nationality', args)"
            />
        </div>

        <div class="label label--half label--no-bottom-padding">
            {{ $t('kycLevel2PostalAddress.country') }}:

            <country-dropdown :country="address"
                :placeholder="$t('kycLevel2PostalAddress.countryHint')"
                @update:country="(args) => $emit('update:address', args)"
            />
        </div>
    </div>
</template>

<script>
// Components
import countryDropdown from '@webapp/components/country-dropdown/country-dropdown.vue';
import customInput from '@webapp/components/form/custom-input.vue';

import {
    noEmojisAllowedForWeb,
} from '@webapp/helpers/validations';

// Validations
import {
    isDateOfBirthOlderThan18,
    validDateOfBirth,
} from '@shared/validations';

export default {
    name: 'step-one-details',
    components: {
        countryDropdown,
        customInput,
    },
    props: {
        firstName: {
            type: String,
            default: '',
        },
        lastName: {
            type: String,
            default: '',
        },
        dateOfBirth: {
            type: String,
            default: '',
        },
        nationality: {
            type: Object,
            default: null,
        },
        address: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            isDateOfBirthValid: false,
            validFirstName: false,
            validLastName: false,
        };
    },
    computed: {
        isFormValid() {
            return Boolean(this.validFirstName &&
                this.validLastName &&
                this.isDateOfBirthValid &&
                this.nationality &&
                this.address);
        },

        dateOfBirthValidations() {
            return [validDateOfBirth, isDateOfBirthOlderThan18];
        },

        nameValidations() {
            return [noEmojisAllowedForWeb];
        },

        minimumAgeYear() {
            const today = new Date();
            const minDate = new Date(today.setFullYear(today.getFullYear() - 18));

            return minDate.toISOString().substring(0, 10);
        },
    },
    watch: {
        isFormValid: {
            handler(value) {
                if (!value) {
                    this.$emit('inProgress');

                    return;
                }

                this.$emit('completed');

            },
            immediate: true,
        },
    },
};
</script>

<style lang="scss" scoped>
    input[type="date"] {
        padding-top: 0.9rem;
        padding-bottom: 0.3rem;
        font-family: "Nunito";
    }
</style>